import type { FC } from "react";

export const AmountUnitSpace: FC = () => (
  <span className="font-inter">&nbsp;</span>
);
